function init() {
  setupEventListeners();
}

function setupEventListeners() {
  // BEGIN CUSTOM EDIT: Enhanced Product View Tracking | Date: 2025-09-12 | What: Track both normal product pages and quick view modals
  document.addEventListener("quickview:loaded", async function(event) {
    var form = document.querySelector("#AddToCartForm-" + event.detail.productId + "-modal");
    
    // Original handlers for existing functionality
    handleViewItemEvent(form);
    handleProductSelectEvent(form);
  });

  // Quick view tracking now handled in Liquid template

  // Product page tracking now handled in Liquid template
  // END CUSTOM EDIT

  // BEGIN CUSTOM EDIT: Cart Drawer Events | Date: 2025-09-12 | What: Enhanced cart drawer event tracking
  document.addEventListener('cart-drawer:open', (event) => {
    handleViewCartEvent(event.detail);
  });

  // Additional cart drawer event listeners for better coverage
  document.addEventListener('click', function(event) {
    // Listen for cart drawer trigger clicks
    if (event.target.matches('.js-drawer-open-cart, [data-drawer-open], .cart-link')) {
      // Multiple attempts to ensure cart view event is triggered
      setTimeout(() => pushStapeCartViewEvent(), 200);
      setTimeout(() => pushStapeCartViewEvent(), 500);
      setTimeout(() => pushStapeCartViewEvent(), 1000);
    }
  });

  // Monitor for cart drawer visibility changes
  if (window.MutationObserver) {
    const cartObserver = new MutationObserver(function(mutations) {
      mutations.forEach(function(mutation) {
        if (mutation.type === 'attributes' && mutation.attributeName === 'class') {
          const target = mutation.target;
          if (target.id === 'CartDrawer' && target.classList.contains('js-drawer-open')) {
            handleViewCartEvent(target);
          }
        }
      });
    });

    // Observe cart drawer for class changes
    document.addEventListener('DOMContentLoaded', function() {
      const cartDrawer = document.querySelector('#CartDrawer');
      if (cartDrawer) {
        cartObserver.observe(cartDrawer, { attributes: true, attributeFilter: ['class'] });
      }
    });
  }
  // END CUSTOM EDIT
}

// Quick view and product page tracking now handled in Liquid template - functions removed

// BEGIN CUSTOM EDIT: Cart View Event | Date: 2025-09-12 | What: Direct function to push Stape cart view event
async function pushStapeCartViewEvent() {
  try {
    // Check if cart drawer is actually visible
    const cartDrawer = document.querySelector('#CartDrawer');
    if (!cartDrawer) {
      return;
    }
    
    // Check if cart drawer is open/visible
    if (!cartDrawer.classList.contains('js-drawer-open') && 
        !cartDrawer.classList.contains('drawer--is-open') &&
        cartDrawer.style.display === 'none') {
      return;
    }
    
    // Fetch current cart data
    const cartItems = await fetchCart();
    if (!cartItems || !cartItems.items) {
      return;
    }
    
    // Prepare Stape items
    let stapeItems = [];
    let totalQuantity = 0;
    
    cartItems.items.forEach((cartItem, index) => {
      stapeItems.push({
        item_name: cartItem.product_title,
        item_id: cartItem.product_id.toString(),
        item_sku: cartItem.sku || "",
        item_brand: cartItem.vendor || "",
        item_category: cartItem.product_type || "",
        item_variant: cartItem.title || "",
        price: parseFloat((cartItem.price / 100).toFixed(2)),
        quantity: cartItem.quantity,
        variant_id: cartItem.id.toString(),
        item_url: cartItem.url || ""
      });
      
      totalQuantity += cartItem.quantity;
    });
    
    // Push the Stape cart view event
    window.dataLayer = window.dataLayer || [];
    const cartViewEvent = {
      event: "view_cart_stape",
      event_source: "cart_drawer_direct",
      cart_quantity: totalQuantity,
      cart_total: parseFloat((cartItems.total_price / 100).toFixed(2)),
      ecommerce: {
        currency: window.Shopify.currency.active,
        value: parseFloat((cartItems.total_price / 100).toFixed(2)),
        items: stapeItems
      }
    };
    
    window.dataLayer.push(cartViewEvent);
    
  } catch (error) {
    // Silent error handling
  }
}
// END CUSTOM EDIT

async function handleViewItemEvent(form) {
  try {
    const product = await fetchProductData(window.location.pathname);
    
    if (!product) {
      return;
    }
    
    const selectedVariantId = form.querySelector(".product-single__variants")?.value;
    
    if (!selectedVariantId) {
      return;
    }
    
    const selectedVariant = product.variants.find((variant) => variant.id == parseInt(selectedVariantId));
    
    if (!selectedVariant) {
      return;
    }

    let variantImage = "";
    variantImage = product.images.find((image) => image.id == selectedVariant.image_id);

    const products = [
      {
        id: selectedVariant.sku, // SKU
        name: product.title, // Product title
        brand: product.vendor,
        category: product.product_type,
        variant: selectedVariant.title,
        price: selectedVariant.price,
        list:
          window.location.pathname.split("/products")[0] ||
          window.location.pathname, // The list the product was discovered from
        product_id: product.id.toString(), // The product_id
        variant_id: selectedVariant.id.toString(), // id or variant_id
        compare_at_price: selectedVariant.compare_at_price || "0.0", // If available on dl_view_item & dl_add_to_cart otherwise use "0.0"
        image: variantImage.src || "", // If available, otherwise use an empty string
        url: window.location.href, // URL for the Product Page. Only required for dl_add_to_cart.
      },
    ];
    
    // BEGIN CUSTOM EDIT: Stape View Item Event | Date: 2025-01-24 | What: Add Stape.io view_item_stape datalayer event for quick modals
    window.dataLayer = window.dataLayer || [];
    window.dataLayer.push({
      event: "view_item_stape",
      event_source: "quick_view_modal",
      ecommerce: {
        currency: window.Shopify.currency.active,
        value: selectedVariant.price,
        items: [
          {
            item_name: product.title,
            item_id: product.id.toString(),
            item_sku: selectedVariant.sku || "",
            item_brand: product.vendor || "",
            item_category: product.product_type || "",
            item_variant: selectedVariant.title || "",
            price: selectedVariant.price,
            variant_id: selectedVariant.id.toString()
          }
        ]
      }
    });
    // END CUSTOM EDIT
  } catch (Error) {
    // Silent error handling
  }
};

async function handleProductSelectEvent(form) {
  try {
    const product = await fetchProductData(window.location.pathname);
    
    if (!product) {
      return;
    }
    
    const selectedVariantId = form.querySelector(".product-single__variants")?.value;
    
    if (!selectedVariantId) {
      return;
    }
    
    const selectedVariant = product.variants.find((variant) => variant.id == parseInt(selectedVariantId));
    
    if (!selectedVariant) {
      return;
    }

    let variantImage = "";
    variantImage = product.images.find((image) => image.id == selectedVariant.image_id);

    const products = [
      {
        id: selectedVariant.sku, // SKU
        name: product.title, // Product title
        brand: product.vendor,
        category: product.product_type,
        variant: selectedVariant.title,
        price: selectedVariant.price,
        list:
          window.location.pathname.split("/products")[0] ||
          window.location.pathname, // The list the product was discovered from
        product_id: product.id.toString(), // The product_id
        variant_id: selectedVariant.id.toString(), // id or variant_id
        compare_at_price: selectedVariant.compare_at_price || "0.0", // If available on dl_view_item & dl_add_to_cart otherwise use "0.0"
        image: variantImage.src || "", // If available, otherwise use an empty string
        url: window.location.href, // URL for the Product Page. Only required for dl_add_to_cart.
      },
    ];

    // Elevar removed - switched to Stape only
  } catch (Error) {
    // Silent error handling
  }
};

async function handleViewCartEvent(drawer) {
  // More flexible drawer validation
  if (!drawer) {
    return;
  }
  
  // Check if it's the cart drawer by ID or find the cart drawer
  let cartDrawer = drawer;
  if (drawer.getAttribute && drawer.getAttribute("id") !== "CartDrawer") {
    cartDrawer = document.querySelector("#CartDrawer");
    if (!cartDrawer) {
      return;
    }
  }
  
  try {
    const cartItems = await fetchCart();
    
    if (!cartItems || !cartItems.items || cartItems.items.length === 0) {
      return;
    }
    
    let stapeItems = [];
    let totalQuantity = 0;
    
    cartItems.items && cartItems.items.forEach((cartItem, index) => {
      // Prepare Stape.io items format with proper data types
      stapeItems.push({
        item_name: cartItem.product_title,
        item_id: cartItem.product_id.toString(),
        item_sku: cartItem.sku || "",
        item_brand: cartItem.vendor || "",
        item_category: cartItem.product_type || "",
        item_variant: cartItem.title || "",
        price: parseFloat((cartItem.price / 100).toFixed(2)), // Ensure proper number format
        quantity: cartItem.quantity,
        variant_id: cartItem.id.toString(),
        item_url: cartItem.url || ""
      });

      totalQuantity += cartItem.quantity;
    });

    // BEGIN CUSTOM EDIT: Stape View Cart Event | Date: 2025-09-12 | What: Optimized Stape.io view_cart_stape event for cart drawer
    window.dataLayer = window.dataLayer || [];
    const cartViewEvent = {
      event: "view_cart_stape",
      event_source: "cart_drawer",
      cart_quantity: totalQuantity,
      cart_total: parseFloat((cartItems.total_price / 100).toFixed(2)),
      ecommerce: {
        currency: window.Shopify.currency.active,
        value: parseFloat((cartItems.total_price / 100).toFixed(2)),
        items: stapeItems.map(item => ({
          ...item,
          price: parseFloat(item.price) // Ensure price is a number
        }))
      }
    };
    
    window.dataLayer.push(cartViewEvent);
    // END CUSTOM EDIT
    
  } catch (error) {
    // Silent error handling
  }
};

function fetchCart() {
  return fetch(window.Shopify.routes.root + 'cart.js')
  .then(response => response.json())
  .then(data => { return data });
}

async function fetchProductData(url) {
  try {
    const response = await fetch(`${url}.json`);

    if (!response.ok) {
      throw new Error("Network response was not ok");
    }

    const productData = await response.json();

    // Assuming product information is nested under 'product' key in the JSON response
    const product = productData.product;

    return product;
  } catch (error) {
    // Handle the error or redirect to an error page
    return null;
  }
}

// BEGIN CUSTOM EDIT: Quick View Modal Fix | Date: 2025-09-12 | What: Helper function to fetch product data by ID for quick view modals
async function fetchProductDataById(productId) {
  try {
    // First try to get the product handle from the modal DOM
    const modalElement = document.querySelector(`#AddToCartForm-${productId}-modal`);
    let productHandle = null;
    
    if (modalElement) {
      // Try to extract product handle from form action or data attributes
      const form = modalElement.closest('form') || modalElement;
      const formAction = form?.action;
      
      if (formAction && formAction.includes('/products/')) {
        const handleMatch = formAction.match(/\/products\/([^\/\?]+)/);
        if (handleMatch) {
          productHandle = handleMatch[1];
        }
      }
      
      // Fallback: look for data attributes
      if (!productHandle) {
        productHandle = form?.dataset?.productHandle || 
                       modalElement?.dataset?.productHandle ||
                       modalElement?.getAttribute('data-product-handle');
      }
    }
    
    // If we have a handle, fetch using the standard method
    if (productHandle) {
      const product = await fetchProductData(`/products/${productHandle}`);
      if (product) {
        return product;
      }
    }
    
    // Fallback: try to find product in existing page data or use Shopify Ajax API
    if (window.ShopifyAnalytics?.meta?.product) {
      const pageProduct = window.ShopifyAnalytics.meta.product;
      if (pageProduct.id == productId) {
        return pageProduct;
      }
    }
    
    // Last resort: try the Ajax Product API (if available)
    try {
      const response = await fetch(`${window.Shopify.routes.root}products.json?ids=${productId}`);
      if (response.ok) {
        const data = await response.json();
        if (data.products && data.products.length > 0) {
          return data.products[0];
        }
      }
    } catch (ajaxError) {
      // Ajax fallback failed
    }
    
    return null;
  } catch (error) {
    return null;
  }
}
// END CUSTOM EDIT

function getUserProperties() {
  if (typeof window === "undefined" || !window.customerData) {
    return {
      user_consent: "",
      visitor_type: "guest",
    };
  }

  const customer = window.customerData.shopifyCustomer;

  if (!customer) {
    return {
      user_consent: "",
      visitor_type: "guest",
    };
  }
  
  const userProperties = {
    // The following fields aren't required if unavailable
    customer_address_1: "",
    customer_address_2: "",
    customer_city: "",
    customer_country: Shopify.country,
    customer_email: customer.email,
    customer_first_name: customer.first_name || "",
    customer_id: customer.id.toString(),
    customer_last_name: customer.last_name || "",
    customer_order_count: customer.orders_count.toString() || "0",
    customer_phone: customer.phone || "",
    customer_province: "",
    customer_province_code: "",
    customer_tags: customer.tags.length > 0 ? customer.tags.join(",") : "",
    customer_total_spent: customer.total_spent || "0.0",
    customer_zip: "",

    // The following fields are required
    user_consent: "", // Use an empty string
    visitor_type: "logged_in", // "logged_in" || "guest"
  };
  
  const mainAddress = customer.addresses?.[0];
  
  if (mainAddress) {
    userProperties.customer_address_1 = mainAddress.address1 ?? "";
    userProperties.customer_address_2 = mainAddress.address2 ?? "";
    userProperties.customer_city = mainAddress.city ?? "";
    userProperties.customer_province = mainAddress.province ?? "";
    userProperties.customer_province_code = mainAddress.province_code ?? "";
    userProperties.customer_zip = mainAddress.zip ?? "";
  }

  return userProperties;
    
  //CHANGE PROPERTIES BELOW
};



document.addEventListener('DOMContentLoaded', () => {
  init();
});

document.addEventListener('DOMContentLoaded', function() {
  const chatLinks = document.querySelectorAll('.js-open-chat');
  chatLinks.forEach(link => {
    link.addEventListener('click', function(e) {
      e.preventDefault();
      if (typeof GorgiasChat !== 'undefined') {
        GorgiasChat.open();
      } else {
        // GorgiasChat not available
      }
    });
  });
});